import { render, staticRenderFns } from "./DisciplineRegister.vue?vue&type=template&id=4cfb59ed&scoped=true&"
import script from "./DisciplineRegister.vue?vue&type=script&lang=js&"
export * from "./DisciplineRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfb59ed",
  null
  
)

export default component.exports